<template>
    <div class="content-container">
        <div class="title">
            <p>语音合成</p>
        </div>
        <!-- <div class="input-container" :style="'margin-bottom:' + marginBottom">
            <span>名称</span>
            <input class="el-title" type="text" v-model="title">
        </div> -->
        <div id="soundList" class="compose-container">
            <div class="l">
                <ul>
                    <li v-for="(list,index) in soundList" @click="changePreviewSound(index);soundIndex = index;soundId = list.id" v-bind:key="index" :class="soundIndex == index ? 'on' : ''">
                        <img v-if="list.sex=='男'" src="./assets/avatar-b.png">
                        <img v-if="list.sex=='女'" src="./assets/avatar-g.png">
                        <div class="info">
                            <p :title="list.name">{{list.name}}</p>
                            <span :title="list.language">({{list.language}})</span>
                        </div>
                        <!-- <div @click.stop="changePreviewSound(index)" :class="soundIndex == index ? 'playBtn on' : 'playBtn'"></div> -->
                    </li>
                </ul>
            </div>
            <div class="r">
                <div class="input-container">
                    <span>名称: </span>
                    <input class="el-title" type="text" v-model="title">
                </div>
                <div ref="content" maxlength="20000" contenteditable="true" id="article" class="compose-content"></div>
                <div class="btn">
                    <div class="left">
                        <!-- <div class="b">
                            <img src="./assets/playBtn.png" alt="">
                            试听
                        </div>
                        <span>仅支持试听前100字</span> -->
                    </div>
                    <div class="right">{{wordNum}}/20000</div>
                </div>
                <div class="btn-container">
                    <div class="left-container">
                        <div class="speed">
                            <p>朗读速度: </p>
                            <div class="speedList">
                                <div @click="showSpeed = !showSpeed" class="speedInput">
                                    <span>{{speed}}</span>
                                    <img :class="{rotate: showSpeed}" src="@assets/img/common/down.png" alt="">
                                </div>
                                <ul v-if="showSpeed" v-click-outside="closeSpeed">
                                    <li @click="speed = item.name;speedIndex = index;showSpeed = false" v-for="(item,index) in speedList" :key="index">{{item.name}}</li>
                                </ul>
                            </div>
                        </div>

                        <div class="btnList">
                            <div class="insertStop">
                                <div :class="{on: showStop}" @click="showStop = !showStop">插入停顿</div>
                                <ul v-if="showStop" v-click-outside="closeStop">
                                    <li @click="stop = item.pause;setPause()" v-for="(item,index) in stopList" :key="index">{{item.name}}</li>
                                </ul>
                            </div>
                            <div class="insertWord">
                                <div :class="{on: showWord}" @click="insertSpell()">插入多音字</div>
                            </div>
                            <div class="insertNum">
                                <div :class="{on: showNum}" @click="insertNum()">标注数值</div>
                                <ul v-if="showNum" v-click-outside="closeNum">
                                    <li @click="num = item.num;setNum()" v-for="(item,index) in numList" :key="index">{{item.name}}</li>
                                </ul>
                            </div>
                            <div class="help">
                                <i></i>
                                <div class="content">
                                    <img src="@assets/img/anchor/trangle.png" alt="">
                                    <span>eg:2008</span>
                                    <span>【数值】二千零八，【数字】二零零八</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right-container">
                        <i></i>
                        <div class="content">
                            请选中文字后插入多音字或标注数值
                        </div>
                        <div @click="compose" class="combtn">
                            <img src="./assets/composeIcon.png" alt="">
                            <span>合成</span>
                        </div>
                    </div>
                </div>
                <!-- <bottomBtn :src="src" @setContent="setContent" @compose="compose"></bottomBtn> -->
            </div>
        </div>
        <div v-if="showWord" class="wordInput-bg">
            <div class="wordInput-container">
                <p>多音字</p>
                <!-- <div class="input-container-box"> -->
                    <div class="input-container">
                        <div v-for="(item,index) in textArr" :key="index" class="input">
                            <span>{{item.name}}</span>
                            <input style="ime-mode:disabled" @input="item.value=item.value.replace(/[\u0391-\uFFE5]/gi,'')" v-model="item.value" placeholder="请输入拼音" type="text">
                            <div class="sb">
                                <p :class="{on: item.status}" @click="setStatus(index)">
                                    <span>{{item.voiceName}}</span>
                                    <img  :class="{rotate: item.status}" src="@assets/img/anchor/downArrow.png" alt="">
                                </p>
                                <ul :style="'top:'+top+'px'" v-if="item.status">
                                    <li @click="item.voiceName = items;item.status=false" v-for="(items,indexs) in sbList" :key="indexs">{{items}}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                <!-- </div> -->
                <div class="btn">
                    <p @click="showWord = false">取 消</p>
                    <p :title="!canConfirm ? '您有拼音尚未输入' : ''" @click="spellConfirm" :class="{on:true,op: !canConfirm}">确 认</p>
                </div>
            </div>
        </div>
        <!-- <bottomBtn :src="src" @setContent="setContent" @compose="compose"></bottomBtn> -->
        <audio id="previewAudio" preload="true"></audio>
        <div ref="filterContent" class="filterContent" contenteditable="true"></div>
    </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import bottomBtn from './btn/bottomBtn';
import qs from 'qs';

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        bottomBtn
    },
    data() {
        return {
            top: 0,
            saveInnerHtmlContent: '',
            showSpeed: false,
            showStop: false,
            showWord: false,
            showNum: false,
            speedList: [
                {name: '1.5X', spd: '+500'},
                {name: '1.2X', spd: '+200'},
                {name: '1.0X', spd: '0'},
                {name: '0.8X', spd: '-200'},
                {name: '0.5X', spd: '-500'}
            ],
            speed: '1.0X',
            speedIndex: 2,
            stopList: [
                {name: '0.1秒', pause: 'p100'},
                {name: '0.2秒', pause: 'p200'},
                {name: '0.4秒', pause: 'p400'},
                {name: '0.6秒', pause: 'p600'},
                {name: '1.0秒', pause: 'p1000'}
            ],
            stop: '',
            numList: [
                {name: '数值', num: 'cardinal'},
                {name: '数字', num: 'digits'}
            ],
            num: '',
            sbList: ['第一声','第二声','第三声','第四声'],
            id: '',
            src: '',
            // speed: 0,
            soundList: [],
            composeConfig: {},
            title: '',
            article: '',
            soundIndex: 0,
            soundId: '',
            audioTime: 0,
            wordSpell: '',
            dialogFormVisible: false,
            myAudio: '',
            loading: false,
            time: '',
            audio: 'javascript:;',
            fz: 0,
            ht: 0,
            liHeight: 0,
            marginBottom: 0,
            totalWidth: 0,
            timeInter: null,
            previewAudio: null,
            canSubmit: true,
            textArr: [],
            saveStr: '',
            range: '',
            sel: '',
            wordNum: 0,
            canConfirm: false
        }
    },
    watch: {
        textArr: {
            deep: true,
            handler: function(n, o) {
                let length = this.textArr.length;
                let index = 0;
                this.textArr.forEach(el => {
                    if(el.value){
                        index ++
                    }
                })

                if(index == length){
                    this.canConfirm = true
                }else{
                    this.canConfirm = false
                }
            }
        }
    },
    methods: {
        spellConfirm() {
            // if(!this.spellInput) return
            // let spell = 1;
            // if (this.sb == '第一声') {
            //     spell = 1;
            // } else if (this.sb == '第二声') {
            //     spell = 2;
            // } else if (this.sb == '第三声') {
            //     spell = 3;
            // } else if (this.sb == '第四声') {
            //     spell = 4;
            // }

            if(!this.canConfirm) return

            let canSubmit = true;
            let str = ''
            let str1 = ''
            let arr = []
            this.textArr.forEach(el => {
                if(!el.value){
                    canSubmit = false;
                }else{
                    let spell = 1;
                    if (el.voiceName == '第一声') {
                        spell = 1;
                    } else if (el.voiceName == '第二声') {
                        spell = 2;
                    } else if (el.voiceName == '第三声') {
                        spell = 3;
                    } else if (el.voiceName == '第四声') {
                        spell = 4;
                    }
                    arr.push(el.value + spell)
                }
            })

            if(!canSubmit) return

            str = arr.join(',')

            str1 = arr.join(' ')

            let content = `<span></span><label class='on'>${this.saveStr}</label><span data-name="phoneme" data-value="${str1}" contenteditable="false" class="contentEditOn">${str}</span>`;

            // let content = `<span contenteditable="false" data-name="[=${this.spellInput}${spell}]" class="contentEditOn">音${this.spellInput}${spell}</span>`;
            this.showWord = false;
            this.spellInput = ''
            this.sb = '第一声'
            this.spell = 1
            this.insertSpell1(content)
        },
        insertSpell1(html) {
            this.range.deleteContents()
            var el = document.createElement('div')
            el.innerHTML = html
            var node
            var lastNode
            while ((node = el.firstChild)) {
                lastNode = this.frag.appendChild(node)
            } 
            this.range.insertNode(this.frag)
            if (lastNode) {
                this.range = this.range.cloneRange()
                this.range.setStartAfter(lastNode)
                this.range.collapse(true)
                this.sel.removeAllRanges()
                this.sel.addRange(this.range)
            }

            this.range = '';
            this.sel = '';
            this.frag = '';
        },
        setStatus(index) {
            let wordInputContainer = document.getElementsByClassName('wordInput-container')[0].getBoundingClientRect().top;
            let li = document.querySelectorAll('.wordInput-container .input-container .input')[index].getBoundingClientRect().top
            this.top = li - wordInputContainer + 42
            this.textArr.forEach((item,i) => {
                if(index == i){
                    if(item.status){
                        item.status = false
                    }else{
                        item.status = true
                    }
                }else{
                    item.status = false
                }
            })
        },
        closeSpeed() {
            this.showSpeed = false;
        },
        closeStop() {
            this.showStop = false;
        },
        closeNum() {
            this.showNum = false;
        },
        setPause() {
            let sec = 0
            let sec1 = 0
            switch (this.stop) {
                case 'p100':
                    sec = 0.1
                    sec1 = 100
                    break;
                case 'p200':
                    sec = 0.2
                    sec1 = 200
                    break;
                case 'p400':
                    sec = 0.4
                    sec1 = 400
                    break;
                case 'p600':
                    sec = 0.6
                    sec1 = 600
                    break;
                case 'p1000':
                    sec = 1.0
                    sec1 = 1000
                    break;
                default:
                    break;
            }
            let content = `<span contenteditable="false" data-name="break" data-value="${Number(sec1)}ms" class="contentEditOn">停${sec}秒</span>`;
            this.showStop = false;
            this.$refs.content.focus();
            this.insertHtml(content)
            this.saveInnerHtmlContent = this.$refs.content.innerHTML
            // this.insertSpell1(content)
        },
        setNum() {
            // let date = new Date().getTime()
            let content = `<span></span><label class='on'>${this.saveStr}</label><span data-name="say-as" data-value="${this.num}" contenteditable="false" class="contentEditOn">${this.num == 'digits' ? '数字' : '数值' }</span>`;
            this.showNum = false;
            this.$refs.content.focus();
            this.insertHtml(content)
            this.saveInnerHtmlContent = this.$refs.content.innerHTML
        },
        setContent(val) {
            this.article = val.value;
            var article = document.getElementById('article');
            setTimeout(function(){
                article.selectionStart = val.startPos;
                article.selectionEnd = val.endPos;
            })
        },
        insertHtml(html) {
            var sel, range, frag
            if (window.getSelection) {
                sel = window.getSelection()
                if (sel.getRangeAt && sel.rangeCount) {
                    range = sel.getRangeAt(0)
                    range.deleteContents()
                    var el = document.createElement('div')
                    el.innerHTML = html
                    frag = document.createDocumentFragment()
                    var node
                    var lastNode
                    while ((node = el.firstChild)) {
                        lastNode = frag.appendChild(node)
                    } range.insertNode(frag)
                    if (lastNode) {
                        range = range.cloneRange()
                        range.setStartAfter(lastNode)
                        range.collapse(true)
                        sel.removeAllRanges()
                        sel.addRange(range)
                        console.log(sel)
                    }
                }
            }
        },
        insertSpell() {
            // var sel, range, frag
            if (window.getSelection) {
                this.sel = window.getSelection()
                let str = this.sel
                str = str.toString()
                if(str.length > 0){
                    if (this.sel.getRangeAt && this.sel.rangeCount) {
                        this.range = this.sel.getRangeAt(0)
                        this.saveStr = str;
                        this.textArr = [];
                        let textArr = str.split('')
                        textArr.forEach(el => {
                            this.textArr.push({
                                name: el,
                                value: '',
                                voiceIndex: 0,
                                voiceName: '第一声',
                                status: false
                            })
                        })
                        // var el = document.createElement('div')
                        // el.innerHTML = html
                        this.frag = document.createDocumentFragment()
                        this.showWord = !this.showWord
                        // var node
                        // var lastNode
                        // while ((node = el.firstChild)) {
                        //     lastNode = frag.appendChild(node)
                        // } range.insertNode(frag)
                        // if (lastNode) {
                        //     range = range.cloneRange()
                        //     range.setStartAfter(lastNode)
                        //     range.collapse(true)
                        //     sel.removeAllRanges()
                        //     sel.addRange(range)
                        // }
                    }
                }else{
                    this.$MediaPlatformNotifyAuth({
                        title: '温馨提示',
                        msg: '您尚未选中任何文字!',
                        btn1: '取消',
                        btn2: '',
                        showIcon: false
                    })
                }
                
            }
        },
        insertNum() {
            // var sel, range, frag
            if (window.getSelection) {
                this.sel = window.getSelection()
                let str = this.sel
                str = str.toString()
                if(str.length > 0){
                    if (this.sel.getRangeAt && this.sel.rangeCount) {
                        this.range = this.sel.getRangeAt(0)
                        // console.log(this.range)
                        // let str = this.range.commonAncestorContainer.textContent.slice(this.range.startOffset, this.range.endOffset)
                        this.saveStr = str;
                        this.frag = document.createDocumentFragment()
                        this.showNum = !this.showNum
                    }
                }else{
                    this.$MediaPlatformNotifyAuth({
                        title: '温馨提示',
                        msg: '您尚未选中任何文字!',
                        btn1: '取消',
                        btn2: '',
                        showIcon: false
                    })
                }
                // console.log(this.sel.toString())
            }
        },
         //某个元素前插入
        afterinsert(newElement,targetElement){
             var parent = targetElement.parentNode;
             if (parent.lastChild === targetElement) {
                 parent.appendChild(newElement);
             }else{
                 parent.insertBefore(newElement,targetElement.previousSibling);
            }
        
        },
        getInnerText() {
            this.$refs.filterContent.innerHTML = this.$refs.content.innerHTML;
            let contentEditOnSpan = document.querySelectorAll('.filterContent .contentEditOn')
            if(contentEditOnSpan){
                for (let index = 0; index < contentEditOnSpan.length; index++) {
                    const element = contentEditOnSpan[index];
                    console.log(element)
                    let name = element.getAttribute('data-name')

                    if(name == 'say-as' || name == 'phoneme'){
                        if(element.previousSibling && element.previousSibling.nodeType){
                            if(element.previousSibling.nodeName == 'LABEL'){
                                element.innerText = element.previousSibling.innerText
                                element.previousSibling.remove()
                            }
                        }
                    }else{
                        if(element.parentNode){
                            if(element.parentNode.nodeName == 'LABEL'){
                                let u = element
                                this.afterinsert(u,element.parentNode)
                                // element.remove()
                            }
                        }
                    }
                    // console.log(name)
                }
                // console.log(contentEditOnSpan)
            }
            // console.log(this.$refs.filterContent.innerHTML)
            // let contentEditOnSpan = document.querySelectorAll('.filterContent .contentEditOnContainer')
            // if(contentEditOnSpan){
            //     for (let index = 0; index < contentEditOnSpan.length; index++) {
            //         const element = contentEditOnSpan[index];
            //         let contentEditOnSpan1 = element.querySelector('.contentEditOn')
            //         console.log(contentEditOnSpan1)
            //     }
            // }
            // this.$refs.filterContent.innerHTML = this.$refs.content.innerHTML;
            // let contentEditOnSpan = document.querySelectorAll('.filterContent .contentEditOn')
            // if(contentEditOnSpan){
            //     console.log(contentEditOnSpan)
            //     for (let index = 0; index < contentEditOnSpan.length; index++) {
            //         const element = contentEditOnSpan[index];
            //         element.innerHTML = element.dataset.name
            //     }
            // }

            let nullSpan = document.querySelectorAll('.filterContent span')

            if(nullSpan){
                for (let index = 0; index < nullSpan.length; index++) {
                    const element = nullSpan[index];
                    // console.log(element)
                    if(!element.getAttribute('class') && element.innerText == ''){
                        element.remove()
                    }
                }
            }

            return this.$refs.filterContent.innerHTML
            // console.log(this.$refs.filterContent.innerText)
        },
        async compose() {
            var that = this;
            // this.speed = val.speed
            if(this.canSubmit){
                this.canSubmit = false;    
                let target_path = that.composeConfig.target;
                target_path = target_path.split('.');
                if(target_path.length > 1){
                    let type = target_path[target_path.length - 1];
                    target_path.splice(-1,1)
                    target_path = target_path.join('.')
                    target_path = target_path + (+new Date()) + '.' + type
                }else{
                    target_path = that.composeConfig.target
                }

                let content = '';

                content = await this.getInnerText()

                // console.log(content)

                // return false;

                if(this.composeConfig.makeup_audio_version == 1){
                    this.$axios({
                        method: 'post',
                        headers: { 'content-type': 'application/x-www-form-urlencoded' },
                        url: that.composeConfig.host+'frontend/web/index.php/api/audioserver/submit',
                        data: qs.stringify({
                            app_id: that.composeConfig.app_id,
                            app_secret: that.composeConfig.app_secret,
                            title: that.title,
                            content: content,
                            vid: that.soundId,
                            spd: that.speed,
                            target_path: target_path
                        })
                    }).then(function(res) {
                        res = res.data;
                        that.$emit('composeComplete',{
                            res: {
                                task_id: res.data&&res.data.task_id,
                                code: res.status,
                                msg: res.msg,
                                spd: that.speedList[that.speedIndex].spd
                            }
                        })
                        that.canSubmit = true;
                    })
                }else{
                    let dataObj = {
                        app_id: that.composeConfig.app_id,
                        app_secret: that.composeConfig.app_secret,
                        title: that.title,
                        content: content,
                        vid: that.soundId,
                        spd: that.speedList[that.speedIndex].spd,
                        target_path: target_path
                    }
                    that.$emit('composeComplete',dataObj)
                    that.canSubmit = true;
                }
            }   
        },
        changePreviewSound(index) {
            var that = this;
            this.soundList.forEach(function(val,key){
                if(index==key){
                    val.status = !val.status;
                    if(val.status){
                        if(that.previewAudio!=null&&that.previewAudio!=undefined&&that.previewAudio!=''){
                            that.previewAudio.pause();
                            that.previewAudio.src = '';
                            that.previewAudio.src = val.preview_url;
                            that.previewAudio.load();
                            that.previewAudio.play();
                        }
                    }
                }else{
                    val.status = false;
                }
            })
        },
        soundlist(composeConfig) {
            var that = this;
            that.composeConfig = composeConfig;
            this.$axios({
                method: 'post',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                url: that.composeConfig.host+'frontend/web/index.php/api/audioserver/voicelist',
                data: qs.stringify({
                    app_id: that.composeConfig.app_id,
                    app_secret: that.composeConfig.app_secret
                })
            }).then(function(res) {
                res = res.data;
                if(res.status == 1){
                    res.data.forEach(function(el){
                        el.status = false;
                    })
                    that.title = that.composeConfig.title;
                    that.article = that.composeConfig.article;
                    that.$refs.content.innerHTML = that.composeConfig.article;
                    that.wordNum = that.composeConfig.article.length;
                    that.soundList = res.data;
                    that.soundId = res.data[0].id;

                    setTimeout(function(){
                        // var composeContainer = document.getElementsByClassName("compose-container");
                        let elem = document.getElementById("soundList");
                        let theCSSprop = window.getComputedStyle(elem,null).getPropertyValue("height");
                        var num = parseFloat(theCSSprop) - 20;
                        // console.log(parseFloat(theCSSprop))
                        that.ht = num+'px';
                    })
                }else{
                    alert(res.msg)
                }
            })
        }
    },
    destroyed() {
        if(this.previewAudio!=null&&this.previewAudio!=undefined&&this.previewAudio!=''){
            this.previewAudio.pause();
            this.previewAudio = null;
        }
    },
    beforeDestroy() {
        if(this.previewAudio!=null&&this.previewAudio!=undefined&&this.previewAudio!=''){
            this.previewAudio.pause();
            this.previewAudio = null;
        }
    },
    mounted() {
        var that = this;

        var audio = document.getElementById('previewAudio');

        this.previewAudio = audio;

        this.$nextTick(function(){
            that.previewAudio.addEventListener("ended",function(){
                that.previewAudio.pause();
                that.previewAudio.src = '';
                that.soundList.forEach(function(el){
                    el.status = false;
                })
            });
        });

        (function (doc, win) {

            var docEl = doc.documentElement,

                resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',

                recalc = function () {

                    var clientWidth = docEl.clientWidth;

                    if (!clientWidth) {

                        return;
                    }
                    var liHeight,marginBottom;
                    if(docEl.clientHeight <= 674) {
                        liHeight = '42px';
                        marginBottom = '12px';
                        that.liHeight = liHeight;
                        that.marginBottom = marginBottom;
                        // var totalHeight = $('.content-container').height();
                    }else if(docEl.clientHeight > 674 && docEl.clientHeight <= 760) {
                        liHeight = '50px';
                        marginBottom = '16px';
                        that.liHeight = liHeight;
                        that.marginBottom = marginBottom;
                    }else{
                        liHeight = '60px';
                        marginBottom = '20px';
                        that.liHeight = liHeight;
                        that.marginBottom = marginBottom;
                    }
                    // var height = 636 - (969-docEl.clientHeight) + 'px';
                    // if(docEl.clientHeight > 674 && docEl.clientHeight <= 760){
                    //     if(636 - (969-docEl.clientHeight) < 350){
                    //         height = '350px'
                    //     }
                    // }
                    // console.log(height)
                    // that.ht = height;
                    var contentContainer = document.getElementsByClassName('content-container')[0];
                    var totalWidth = contentContainer.style.width;
                    // var totalWidth = $('.content-container').width();
                    that.totalWidth = totalWidth;
                    var width = totalWidth - 280 + 'px';
                    that.fz = width;

                };

                recalc();

            if (!doc.addEventListener) {

                return;
            }

            win.addEventListener(resizeEvt, recalc, false);

            doc.addEventListener('DOMContentLoaded', recalc, false);

        })(document, window);

        if(this.$refs.content){
            this.$refs.content.addEventListener('focus', () => {
                this.showPlaceHolder = false
            })
            this.$refs.content.addEventListener('blur', () => {
                if(!this.$refs.content.innerText){
                    this.showPlaceHolder = true
                }   
            })

            this.$refs.content.addEventListener('paste', (e) => {
                e.preventDefault();
                e.stopPropagation();
                // console.log(e.clipboardData.getData('text'))
                this.$refs.content.innerHTML += e.clipboardData.getData('text')
            })

            this.$refs.content.addEventListener('keydown',e=>{
                var ev = e || window.event
                let contentEditOn = document.getElementsByClassName('contentEditOn')
                let numLength = 0
                for (let index = 0; index < contentEditOn.length; index++) {
                    const element = contentEditOn[index];
                    numLength += element.innerText.length
                }
                // console.log(ev)
                

                if (ev.target.innerText.length - numLength > 20000 && ev.keyCode !== 8 && ev.keyCode !== 116) {
                    ev.preventDefault()
                }
            })

            this.$refs.content.addEventListener("keyup",e=>{
                let composeContent = document.getElementsByClassName('compose-content')[0]
                let labelDom = composeContent.getElementsByTagName('label')
                console.log(labelDom)
                if(labelDom){
                    for (let index = 0; index < labelDom.length; index++) {
                        const element = labelDom[index];
                        if(element.nextSibling){
                            if(element.nextSibling.nodeType == 3){
                                element.classList.remove('on')
                            }else if(!element.nextSibling.classList.contains('contentEditOn')){
                                element.classList.remove('on')
                            }
                        }else{
                            console.log(element)
                            element.classList.remove('on')
                        }
                        // console.log(element.nextSibling)
                    }
                }
            })

            this.$refs.content.addEventListener("input", (e) => {
                
                let ev = e || window.event
                let contentEditOn = document.getElementsByClassName('contentEditOn')

                let numLength = 0
                for (let index = 0; index < contentEditOn.length; index++) {
                    const element = contentEditOn[index];
                    numLength += element.innerText.length
                }
                // console.log(ev)
                if (ev.target.innerText.length - numLength > 20000 && ev.inputType !== "deleteContentBackward") {
                    setTimeout(() => {
                        // ev.target.innerText = ev.target.innerText.substring(0, 800)
                        // ev.target.innerHTML = this.saveInnerHtmlContent
                        let wordNum = e.target.innerText.length + numLength
                        console.log(wordNum)
                        if(wordNum >= 0){
                            this.wordNum = wordNum
                        }else{
                            this.wordNum = 0
                        }
                        // ev.preventDefault()
                        keepLastIndex(ev.target)
                    }, 0)
                }else{
                    this.saveInnerHtmlContent = ev.target.innerHTML
                }

                let wordNum = e.target.innerText.length + numLength
                console.log(e.target.innerText.length,wordNum,numLength)
                if(wordNum >= 0){
                    this.wordNum = wordNum
                }else{
                    this.wordNum = 0
                }
                if(e.target.innerText.length > 0){
                    this.pendingNext = false;
                }else{
                    this.pendingNext = true;
                }

                function keepLastIndex(obj) {
                    if (window.getSelection) { //ie11 10 9 ff safari
                        obj.focus(); //解决ff不获取焦点无法定位问题
                        var range = window.getSelection(); //创建range
                        range.selectAllChildren(obj); //range 选择obj下所有子内容
                        range.collapseToEnd(); //光标移至最后
                    } else if (document.selection) { //ie10 9 8 7 6 5
                        var range = document.selection.createRange(); //创建选择对象
                        //var range = document.body.createTextRange();
                        range.moveToElementText(obj); //range定位到obj
                        range.collapse(false); //光标移至最后
                        range.select();
                    }
                }
            });
        }
        
    },
    created() {
        
        // this.soundlist();
    }
}
</script>

<style lang="less" scoped>
    .filterContent {
        position: absolute;
        top: -10000000px;
    }
    .wordInput-bg {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .wordInput-container {
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 999999;
            // margin-left: -215px;
            // margin-top: -96px;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            width: 430px;
            max-height: 284px;
            background: #FFFFFF;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.1);
            border-radius: 4px;
            padding: 20px 30px;
            box-sizing: border-box;

            &>p {
                font-size: 16px;
                line-height: 24px;
                color: #000000;
                font-weight: bold;
                margin-bottom: 24px;
            }

            .input-container {
                display: flex;
                flex-direction: column;
                width: 100%;
                max-height: 138px;
                overflow-y: auto;

                &::-webkit-scrollbar {
                    width: 4px;
                }
                &::-webkit-scrollbar-thumb {
                    background: rgba(#dcdcdc, 1);
                    border-radius: 4px;
                }
            }

            .input {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                margin-bottom: 14px;

                &>span {
                    font-size: 14px;
                    color: #050F0F;
                }

                input {
                    width: 234px;
                    height: 32px;
                    line-height: 32px;
                    background: #F1F3F3;
                    border-radius: 2px;
                    border: none;
                    padding: 0 12px;
                    font-size: 14px;
                }

                .sb {
                    // position: relative;

                    .rotate {
                        transform: rotate(180deg);
                    }

                    p {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        width: 88px;
                        height: 32px;
                        background: #F1F3F3;
                        border-radius: 2px;

                        &.on {
                            border: 1px solid #41B48C;
                            box-sizing: border-box;
                        }

                        span {
                            display: block;
                            flex: 1;
                            height: 100%;
                            line-height: 32px;
                            text-align: center;
                            font-size: 14px;
                            color: #050F0F;
                        }

                        img {
                            user-select: none;
                            cursor: pointer;
                        }
                    }

                    &>ul {
                        position: absolute;
                        // top: 40px;
                        // left: 0px;
                        z-index: 9;
                        display: flex;
                        flex-direction: column;
                        width: 88px;
                        background: #FFFFFF;
                        box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                        border-radius: 4px;
                        margin-top: 10px;
                        // display: none;

                        li {
                            width: 100%;
                            height: 30px;
                            line-height: 30px;
                            font-size: 12px;
                            color: #050F0F;
                            text-align: center;
                            user-select: none;
                            cursor: pointer;

                            &:hover {
                                background: rgba(65, 180, 140, 0.15);
                            }
                        }
                    }
                }
            }

            .btn {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                margin-top: 16px;

                p {
                    width: 88px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    border-radius: 4px;
                    border: 1px solid #B9C3C3;
                    font-size: 14px;
                    color: #262626;
                    margin-right: 10px;
                    box-sizing: border-box;
                    user-select: none;
                    cursor: pointer;

                    &.on {
                        background: #41B48C;
                        border: 1px solid #41B48C;
                        box-sizing: border-box;
                        color: #FFFFFF;
                    }

                    &.op {
                        opacity: 0.5;
                    }
                }
            }
        }
    }
    .btn-container {
        position: absolute;
        bottom: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        min-height: 58px;
        background: #FFFFFF;
        box-shadow: 0px 0px 10px 0px rgba(5, 10, 15, 0.1);
        padding: 0 20px;
        box-sizing: border-box;

        .left-container {
            display: flex;
            flex-direction: row;
            align-items: center;

            .speed {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-right: 20px;

                p {
                    font-size: 14px;
                    color: #050F0F;
                    line-height: 20px;
                    font-weight: 500;

                    &:nth-of-type(1) {
                        min-width: 60px;
                    }
                }

                .speedList {
                    position: relative;
                    margin: 0 8px;

                    .speedInput {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        width: 70px;
                        height: 30px;
                        line-height: 30px;
                        background: #F1F3F3;
                        border-radius: 2px;
                        padding: 0 6px 0 12px;
                        user-select: none;
                        cursor: pointer;

                        span {
                            font-size: 14px;
                            color: #050F0F;
                        }
                    }

                    ul {
                        position: absolute;
                        bottom: 40px;
                        left: -9px;
                        z-index: 1;
                        display: flex;
                        flex-direction: column;
                        flex-wrap: nowrap;
                        width: 78px;
                        height: auto;
                        background: #FFFFFF;
                        box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                        border-radius: 4px;
                        overflow: unset;
                        // display: none;

                        li {
                            display: flex;
                            justify-content: center;
                            width: 100%;
                            height: 30px;
                            line-height: 30px;
                            font-size: 12px;
                            color: #050F0F;
                            user-select: none;
                            cursor: pointer;
                            margin-bottom: 0;
                            text-align: center;
                            background: #FFF;

                            &:hover {
                                background: rgba(65, 180, 140, 0.15);
                            }
                        }
                    }
                }
            }

            .btnList {
                display: flex;
                flex-direction: row;
                align-items: center;

                &>div {
                    margin-right: 20px;

                    &:nth-last-of-type(1) {
                        margin-right: 6px;
                    }
                }

                .insertStop {
                    position: relative;

                    div {
                        width: 78px;
                        height: 30px;
                        background: rgba(185, 195, 195, 0.2);
                        border-radius: 4px;
                        border: 1px solid #DCDCDC;
                        font-size: 14px;
                        color: #050F0F;
                        line-height: 30px;
                        text-align: center;
                        user-select: none;
                        cursor: pointer;

                        &.on {
                            color: #41B48C;
                                    background: #E6F1ED;
                                    border: 1px solid #41B48C;
                                }
                            }

                            ul {
                                position: absolute;
                                bottom: 40px;
                                left: 0px;
                                display: flex;
                                flex-direction: column;
                                width: 78px;
                                height: auto;
                                background: #FFFFFF;
                                box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                                border-radius: 4px;
                                // display: none;
    
                                li {
                                    display: flex;
                                    justify-content: center;
                                    width: 100%;
                                    height: 30px;
                                    line-height: 30px;
                                    font-size: 12px;
                                    color: #050F0F;
                                    text-align: center;
                                    user-select: none;
                                    cursor: pointer;
                                    background: #FFF;
                                    margin-bottom: 0;
    
                                    &:hover {
                                        background: rgba(65, 180, 140, 0.15);
                                    }
                                }
                            }
                        }

                        .insertWord {
                            position: relative;

                            div {
                                width: 93px;
                                height: 30px;
                                background: rgba(185, 195, 195, 0.2);
                                border-radius: 4px;
                                border: 1px solid #DCDCDC;
                                font-size: 14px;
                                color: #050F0F;
                                line-height: 30px;
                                text-align: center;
                                user-select: none;
                                cursor: pointer;

                                &.on {
                                    color: #41B48C;
                                    background: #E6F1ED;
                                    border: 1px solid #41B48C;
                                }
                            }
                        }

                        .insertNum {
                            position: relative;
                            margin-right: 6px;

                            &>div:nth-of-type(1) {
                                width: 78px;
                                height: 30px;
                                background: rgba(185, 195, 195, 0.2);
                                border-radius: 4px;
                                border: 1px solid #DCDCDC;
                                font-size: 14px;
                                color: #050F0F;
                                line-height: 30px;
                                text-align: center;
                                user-select: none;
                                cursor: pointer;

                                &.on {
                                    color: #41B48C;
                                    background: #E6F1ED;
                                    border: 1px solid #41B48C;
                                }
                            }

                            &>ul {
                                position: absolute;
                                bottom: 40px;
                                left: 0px;
                                display: flex;
                                flex-direction: column;
                                flex-wrap: nowrap;
                                width: 78px;
                                height: auto;
                                background: #FFFFFF;
                                box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                                border-radius: 4px;
                                overflow: unset;
                                // display: none;
    
                                li {
                                    display: flex;
                                    justify-content: center;
                                    width: 100%;
                                    height: 30px;
                                    line-height: 30px;
                                    font-size: 12px;
                                    color: #050F0F;
                                    text-align: center;
                                    user-select: none;
                                    cursor: pointer;
                                    background: #FFF;
                                    margin-bottom: 0;
    
                                    &:hover {
                                        background: rgba(65, 180, 140, 0.15);
                                    }
                                }
                            }
                        }

                        .help {
                            position: relative;

                            i {
                                display: block;
                                width: 16px;
                                height: 16px;
                                background: url('../../assets/img/anchor/help.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                cursor: pointer;

                                &:hover {
                                    background: url('../../assets/img/anchor/helpOn.png') no-repeat;

                                    &+.content {
                                        display: flex;
                                    }
                                }
                            }

                            .content {
                                display: none;
                                flex-direction: column;
                                position: absolute;
                                bottom: 31px;
                                left: 50%;
                                z-index: 2;
                                width: 228px;
                                height: 54px;
                                background: rgba(30,39,34,0.89);
                                padding: 6px 12px;
                                border-radius: 4px;
                                box-sizing: border-box;
                                margin-left: -114px;

                                img {
                                    position: absolute;
                                    bottom: -9px;
                                    left: 50%;
                                    margin-left: -8px;
                                    transform: rotate(180deg);
                                }

                                span:nth-of-type(1) {
                                    font-size: 12px;
                                    line-height: 20px;
                                    color: #41B48C;
                                    font-weight: bold;
                                }

                                span:nth-of-type(2) {
                                    font-size: 12px;
                                    line-height: 20px;
                                    color: #FFF;
                                    font-weight: bold;
                                }
                            }
                        }

                        .line {
                            width: 1px;
                            height: 20px;
                            background: #DCDCDC;
                            margin: 0 20px;
                        }
                    }
                }

                .right-container {
                    position: relative;
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    i {
                        display: block;
                        width: 16px;
                        height: 16px;
                        background: url('../../assets/img/anchor/noticeOn.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        cursor: pointer;

                        // &:hover {
                        //     background: url('../../assets/img/anchor/noticeOn.png') no-repeat;
                        
                        //     &+.content {
                        //         display: flex;
                        //     }
                        // }
                    }

                    .content {
                        display: flex;
                        flex-direction: column;
                        font-size: 12px;
                        color: #41B48C;
                        margin-left: 3px;
                        margin-right: 10px;
                        // position: absolute;
                        // top: 31px;
                        // right: -20px;
                        // z-index: 2;
                        // min-width: 132px;
                        // background: rgba(30,39,34,0.89);
                        // padding: 6px 12px;
                        // border-radius: 4px;
                        // box-sizing: border-box;

                        // img {
                        //     position: absolute;
                        //     top: -9px;
                        //     right: 20px;
                        // }

                        // span {
                        //     font-size: 12px;
                        //     line-height: 20px;
                        //     color: #FFF;
                        //     font-weight: bold;
                        //     text-align: center;
                        // }
                    }

                    .combtn {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        width: 88px;
                        height: 32px;
                        background: #41B48C;
                        border-radius: 4px;
                        user-select: none;
                        cursor: pointer;

                        img {
                            margin-right: 6px;
                            width: 16px;
                            height: 14px;
                        }

                        span {
                            font-size: 14px;
                            font-weight: bold;
                            color: #FFF;
                        }
                    }
                }
            }
    .content-container {
        display: flex;
        flex-direction: column;
        position: relative;
        width: 100%;
        height: 100%;
        /* min-height: 100%; */
        background: #E6EBF0;
        /* padding: 20px 30px;
        box-sizing: border-box; */
        overflow: hidden;
    }

    /*滚动条样式*/
    .content-container::-webkit-scrollbar {/*滚动条整体样式*/
        width: 8px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 4px;
    }
    .content-container::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }
    .content-container::-webkit-scrollbar-track {/*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
    }

    .content-container .title {
        display: flex;
        align-items: center;
        overflow: hidden;
        /* height: 41px; */
        font-size: 24px;
        min-height: 72px;
        /* line-height: 33px; */
        color: #32323C;
        background-color: #F9F9F9;
        margin: 0 0 20px 0;
        user-select: none;
        padding: 0px 30px 0px;
        box-sizing: border-box;
        box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
    }

    .content-container .title p {
        float: left;
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
    }

    .content-container .title span {
        float: right;
    }

    .content-container .title span:before {
        display: inline-block;
        content: '<';
        margin-right: 5px;
    }

    .content-container .r .input-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        overflow: hidden;
        /* margin-bottom: 15px; */
        width: 100%;
        min-height: 58px;
        background: #FFFFFF;
        box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
        border-radius: 4px 4px 0px 0px;
        padding: 0px 20px 0;
        box-sizing: border-box;
    }

    .content-container .r .input-container span {
        font-size: 14px;
        color: #050F0F;
        float: left;
        margin-right: 8px;
        user-select: none;
    }

    .content-container .r .input-container .el-input {
        width: 320px !important;
        height: 34px !important;
        background: #F1F3F3 !important;
        border-radius: 2px !important;
    }

    .content-container .r .input-container .fileIn {
        width: 120px;
        height: 40px;
        padding-left: 0px;
        padding-right: 0px;
    }

    .content-container .r .input-container .fileIn span {
        display: flex;
        flex-direction: row;
    }

    .content-container .r .input-container .fileIn span i.inIcon {
        float: left;
        display: block;
        width: 17px;
        height: 17px;
        background: url('./assets/inIcon.png') no-repeat;
        background-size: 100%;
        background-position: center;
        line-height: 40px;
        margin-left: 16px;
        margin-right: 12px;
    }

    .content-container .input-container .fileIn span > span {
        float: left;
        margin: 2px 0 0 0;
        color: #666;
    }

    .content-container .input-container .save {
        background: #56BCDE;
        border: 1px solid #56BCDE;
        box-sizing: border-box;
        color: #FFF;
        padding: 0px;
        width: 100px;
        height: 36px;
        box-sizing: border-box;
    }

    .content-container .input-container .fileOut {
        background: #56BCDE;
        border: 1px solid #56BCDE;
        box-sizing: border-box;
        color: #FFF;
        padding: 0px;
        width: 100px;
        height: 36px;
        box-sizing: border-box;
    }

    .content-container .input-container .fileOut > span i.outIcon {
        float: left;
        display: block;
        width: 16px;
        height: 16px;
        background: url('./assets/outIcon.png') no-repeat;
        background-size: 100%;
        background-position: center;
        /* margin: 0 16px; */
    }

    .content-container .input-container .fileOut > span > a {
        float: left;
        margin: 2px 0 0 0;
    }

    .content-container .input-container .save > span i.saveIcon {
        float: left;
        display: block;
        width: 16px;
        height: 16px;
        background: url('./assets/saveIcon.png') no-repeat;
        background-size: 100%;
        background-position: center;
        margin: 0 16px;
    }

    .content-container .input-container .save > span > span {
        float: left;
        font-size: 14px;
        color: #FFF;
        margin: 2px 0 0 0;
    }

    .content-container .input-container .btn-container {
        float: right;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .content-container .input-container .btn-container .el-button {
        margin: 0px;
        /* margin-right: 20px; */
    }

    .content-container .input-container .btn-container .el-button:nth-of-type(2) {
        margin-left: 20px;
    }

    .content-container .input-container .btn-container .el-button:nth-of-type(3) {
        margin-left: 20px;
    }

    /* .content-container .input-container .fileOut:hover a {
        color: #409EFf !important;
    } */

    .content-container .compose-container {
        /* flex: 1; */
        width: 100%;
        height: 558px;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0px 20px 0px;
        box-sizing: border-box;
        /* margin-bottom: 12px; */
    }

    .content-container .compose-container .l {
        width: 266px;
        height: 100%;
        /* padding-right: 10px; */
        padding: 20px 6px 20px 20px;
        box-sizing: border-box;
        background: #FCFEFF;
        box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
        border-radius: 4px 4px 0px 0px;
        margin-right: 10px;
    }

    .content-container .compose-container .r {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 874px;
        height: 100%;
        background: #FCFEFF;
        box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
        border-radius: 4px 4px 0px 0px;
        /* padding: 20px 20px 12px; */
        box-sizing: border-box;
    }

    .content-container .compose-container .r .btn {
        // position: absolute;
        // bottom: 78px;
        // right: 40px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        box-sizing: border-box;
        /* width: 100%; */
    }

    .content-container .compose-container .r .btn .left {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .content-container .compose-container .r .btn .left .b {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #41B48C;
        width: 90px;
        height: 30px;   
        border-radius: 15px;
        border: 1px solid #41B48C;
        box-sizing: border-box;
        user-select: none;
        cursor: pointer;
        margin-right: 15px;
    }

    .content-container .compose-container .r .btn .left span {
        font-size: 12px;
        color: #B9C3C3;
    }

    .content-container .compose-container .r .btn .left .b img {
        width: 12px;
        height: 14px;
        margin-right: 9px;
    }

    .content-container .compose-container .r .btn .right {
        font-size: 12px;
        color: #B9C3C3
    }

    .content-container .compose-container ul {
        /* width: 17%; */
        /* min-width: 206px; */
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        height: 100%;
        /* margin-left: 50px; */
        /* margin-left: 50px; */
        overflow-y: auto;
    }

    /*滚动条样式*/
    .content-container .compose-container ul::-webkit-scrollbar {/*滚动条整体样式*/
        width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 2px;
    }
    .content-container .compose-container ul::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(185,195,195,0.5);
    }
    .content-container .compose-container ul::-webkit-scrollbar-track {/*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0,0,0,0);
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0);
        border-radius: 0;
        background: rgba(0,0,0,0);
    }

    .content-container .compose-container ul li {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 226px;
        height: 50px;
        background: rgba(185, 195, 195, 0.15);
        color: #5F5F5F;
        padding: 0 14px;
        /* border-bottom: 1px solid #ccc; */
        border-radius: 4px;
        border: 1px solid transparent;
        box-sizing: border-box;
        cursor: pointer;
        margin: 0 0px 10px 0;
        /* margin-bottom: 1px; */
    }

    .content-container .compose-container ul li:nth-of-type(2n+2) {
        margin: 0 0 10px 0;
    }

    .content-container .compose-container ul li img {
        width: 40px;
        height: 40px;
        /* margin: 0 16px 0 20px; */
        user-select: none;
    }

    .content-container .compose-container ul li .info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 146px;
        /* overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap; */
    }

    .content-container .compose-container ul li P {
        /* width: 42px; */
        width: 80px;
        font-size: 16px;
        font-weight: bold;
        color: #000000;
        user-select: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .content-container .compose-container ul li span {
        display: flex;
        width: 56px;
        font-size: 14px;
        color: #829191;
        user-select: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .content-container .compose-container ul li .playBtn {
        width: 26px;
        height: 26px;
        background: url('./assets/newPlay.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }

    .content-container .compose-container ul li .playBtn.on {
        width: 26px;
        height: 26px;
        background: url('./assets/newPlayOn.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }

    .content-container .compose-container ul li.on {
        background: #E6F1ED;
        color: #000000;
        border: 1px solid #41B48C;
        box-sizing: border-box;
    }

    .content-container .compose-container ul li.on p {
        color: #000000;
    }

    .content-container .compose-container ul li.on span {
        color: #829191;
    }

    .content-container .compose-container ul li.on .playBtn {
        width: 26px;
        height: 26px;
        background: url('./assets/newPlay.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }

    .content-container .compose-container ul li.on .playBtn.on {
        width: 26px;
        height: 26px;
        background: url('./assets/newPlayOn.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }

    .content-container .compose-container ul li:hover {
        background: #E6F1ED;
        color: #000000;
        border: 1px solid #41B48C;
        box-sizing: border-box;
    }

    .content-container .compose-container .compose-content{
        position: relative;
        width: 100%;
        height: 414px;
        /* width: 100%; */
        /* height: 630px; */
        /* height: 420px; */
        /* min-height: 294px; */
        background: #FCFEFF;
        font-size: 14px;
        color: #050F0F !important;
        font-weight: bold;
        box-sizing: border-box;
        /* border: 1px solid #DDD; */
        outline-style: none;
        resize: none;
        overflow-y: auto;
        line-height: 30px;
        margin-top: 8px;
        padding: 10px 20px 0;
        /* margin-bottom: 10px; */
    }

    /*滚动条样式*/
    .content-container .compose-container .compose-content::-webkit-scrollbar {/*滚动条整体样式*/
        width: 5px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 4px;
    }
    .content-container .compose-container .compose-content::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }
    .content-container .compose-container .compose-content::-webkit-scrollbar-track {/*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgb(255,255,255);
        -webkit-box-shadow: inset 0 0 5px rgb(255,255,255);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
    }

    .bottom-btn {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 88px;
        background: rgba(0,0,0,0.4);
    }

    #audio {
        position: absolute;
        top: -1000px;
        left: 0px;
    }

    .mask-container {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -120px;
        margin-top: -67.5px;
        width: 240px;
        height: 135px;
        background: rgba(0,0,0,0.7);
        border-radius: 4px;
    }

    .mask-container img {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -23.5px;
        margin-top: -23.5px;
        width: 47px;
        height: 47px;
        animation: "rotate" 1s infinite;
    }

    .downloadAudio {
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: #FFF;
        /* padding-left: 16px; */
        /* box-sizing: border-box; */
    }

    .downloadAudio span {
        color: #FFF !important;
        margin: 0px !important;
    }

    .downloadAudio i {
        /* margin-left: 16px; */
        margin-right: 14px;
    }

    @keyframes rotate {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360);
        }
    }

    .el-title {
        width: 320px;
        height: 34px;
        font-size: 14px;
        background: #F1F3F3;
        border-radius: 2px;
        -webkit-appearance: none;
        background-image: none;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    }
</style>
<style lang="less">
.compose-content {
        span {
            display: inline-flex;
            min-width: 2px;
            // line-height: 19px;
            min-height: 19px;
        }
    }
    .contentEditOn {
        display: inline-block;
        color: #41B48C;
        height: 24px;
        line-height: 24px;
        padding: 0 10px;
        box-sizing: border-box;
        background: #E6F1ED;
        border-radius: 4px;
        border: 1px solid #41B48C;
        box-sizing: border-box;
        margin: 0 3px;
        font-size: 13px;
        font-weight: normal;
    }

    .compose-content label.on {
        color: #41B48C;
    }
</style>